import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex flex-column gap-2"
};
const _hoisted_2 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_3 = { class: "tag-link-url mr-1" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
    key: 1,
    class: "my-2"
};
const _hoisted_6 = { class: "tag-link-url mr-1" };
const _hoisted_7 = ["onClick"];
import { LinkType } from "@/entities/card.entity";
import Tag from "primevue/tag";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskLinks',
    props: {
        links: {}
    },
    setup(__props) {
        const props = __props;
        const mandatoryLinks = computed(() => props.links.filter(l => l.type == LinkType.Required));
        const optionalLinks = computed(() => props.links.filter(l => l.type == LinkType.Optional));
        const openLink = (url) => {
            window.open(url, "_blank");
        };
        return (_ctx, _cache) => {
            return (props.links?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (mandatoryLinks.value.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Main"))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mandatoryLinks.value, (link, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createVNode(_unref(Tag), {
                                icon: "pi pi-link",
                                severity: link.type === _unref(LinkType).Required ? 'primary' : 'secondary'
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(link.label), 1),
                                    _createElementVNode("i", {
                                        class: "pi pi-external-link",
                                        style: { "cursor": "pointer" },
                                        onClick: ($event) => (openLink(link.value))
                                    }, null, 8, _hoisted_4)
                                ]),
                                _: 2
                            }, 1032, ["severity"])
                        ]));
                    }), 128)),
                    (optionalLinks.value.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Other"))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionalLinks.value, (link, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createVNode(_unref(Tag), {
                                icon: "pi pi-link",
                                severity: link.type === _unref(LinkType).Required ? 'primary' : 'secondary'
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(link.label), 1),
                                    _createElementVNode("i", {
                                        class: "pi pi-external-link",
                                        style: { "cursor": "pointer" },
                                        onClick: ($event) => (openLink(link.value))
                                    }, null, 8, _hoisted_7)
                                ]),
                                _: 2
                            }, 1032, ["severity"])
                        ]));
                    }), 128))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
